













import { Component, Prop, Vue } from "vue-property-decorator";
import { Match } from "@/types";
import { State } from "vuex-class";

@Component
export default class MatchList extends Vue {
  @Prop() private matches!: Match[];

  @Prop()
  private text!: string;

  private classes(obj: object, prefix: string): object {
    return [
      prefix,
      ...Object.entries(obj).map(([key, value]) => `${prefix}-${key}-${value}`)
    ];
  }

  get document() {
    return this.text || this.$store.state.text;
  }

  private getText(match: Match) {
    return this.document
      .slice(...match.concept.text.charpos)
      .replace("\n", " ")
      .toLowerCase();
  }
}
